<script>
  import formatDateMixin from '@mixins/FormatDateMixin.vue'

  export default {
    mixins: [formatDateMixin],
    props: {
      value: {
        type: String,
        default: null,
      },
      isSqlDate:{
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      customClasses: {
        type: String,
        default: 'tw-mb-3',
      }
    },
    data() {
      return {
        formattedValue: this.isSqlDate ? this.formatSQLTimestamp(this.value) : this.formatDate(this.value, 'yyyy-MM-dd'),
        selectedValue: this.value || null,
      }
    },
    watch: {
      value: function (newValue) {
        this.selectedValue = newValue;
        this.formattedValue = this.formatDate(newValue, 'yyyy-MM-dd');
      },
      selectedValue: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    methods: {
      onContext(ctx) {
        this.selectedValue = ctx.selectedYMD;
        this.formattedValue = this.formatDate(ctx.selectedYMD, 'yyyy-MM-dd');
      },
      updateClass(removeClass = false){
        const datePickerAppendElement = this.$refs.datePicker.$el.children[0];
        if (removeClass){
          datePickerAppendElement.classList.remove('!tw-border-primary');
          datePickerAppendElement.classList.remove('!tw-bg-primary');
        }else{
          datePickerAppendElement.classList.add('!tw-border-primary');
          datePickerAppendElement.classList.add('!tw-bg-primary');
        }
      },
    },
  }
</script>

<template>
  <FabricSectionGroup :class="customClasses">
    <input 
      v-model="formattedValue"
      class="b-form-datepicker form-control !tw-border-r-0" 
      type="text" 
      disabled="disabled" 
      placeholder="YYYY-MM-DD" 
      autocomplete="off" 
      readonly="readonly" />
    <template slot="append">
      <div class="input-group-append">
        <FabricDatePicker
          v-model="selectedValue"
          class="round-child"
          :disabled="disabled"
        />
      </div>
    </template>
  </FabricSectionGroup>
</template>

<style lang="scss">
  .input-group-append > section.round-child > * {
    @apply tw-rounded-tr-lg;
    @apply tw-rounded-br-lg;
  }
</style>
